import Avatar from '@mui/material/Avatar';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import BlockIcon from '@mui/icons-material/Block';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

type AvatarStyles = { color: string; bgcolor?: string };

const getIcon = (status: string) => {
  switch (status) {
    case 'SUCCESS':
    case 'PENDING':
      return <DoneAllIcon />;
    case 'REQUESTED':
      return <AddIcon />;
    case 'ERRORED':
    case 'REVERSED':
      return <ClearIcon />;
    case 'CANCELED':
      return <BlockIcon />;
    case 'CONFIRMED':
    default:
      return <DoneIcon />;
  }
};

const StatusIcon = ({
  status,
  showProgress = false,
}: {
  status: string;
  showProgress?: boolean;
}): JSX.Element => {
  const style: AvatarStyles = { color: '#fff' };
  if (status === 'SUCCESS') {
    style.bgcolor = 'success.main';
  } else if (status === 'ERRORED' || status === 'REVERSED') {
    style.bgcolor = 'error.main';
  }
  return (
    <Box sx={{ position: 'relative' }}>
      <Avatar sx={style}>{getIcon(status)}</Avatar>
      {showProgress && (
        <CircularProgress
          size={48}
          sx={{
            color: 'success.light',
            position: 'absolute',
            top: -4,
            left: -4,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};

export default StatusIcon;
